import * as uiConstants from './ui/constants'
import * as backendConstants from './backend/constants'
import * as serversConstants from './servers/constants'
import * as displayConstants from './display/constants'

// eslint-disable-next-line
export const constants = {
    display: displayConstants,
    backend: backendConstants,
    ui: uiConstants,
    servers: serversConstants,
    UI_SETTINGS_CHANGED: 'SETTINGS_UI_SETTINGS_CHANGED',
    BACKEND_SETTINGS_CHANGED: 'SETTINGS_BACKEND_SETTINGS_CHANGED',
    LANGUAGE_CHANGED: 'SETTINGS_LANGUAGE_CHANGED',
    FORGET_ALL: 'SETTINGS_FORGET_ALL_PINNED_USERS',
}



// WEBPACK FOOTER //
// ./src/features/Settings/data/constants.js